<h1>{{ 'MAIN_DASHBOARD.WS_DIRECTORY' | translate }}</h1>

<div class="content-container admin m-t-20">
  <div class="ui-g">
    <div class="ui-g-12">

      <h3>{{ 'USER_ROLES.HEADER' | translate }}</h3>
      <label>{{ 'USER_ROLES.ROLE_LABEL' | translate }}</label>
      <div class="ui-g">
        <div class="ui-g-4">
          <p-dropdown [options]="userRolesOptions"
                      placeholder="{{ 'USER_ROLES.ROLE_PLACEHOLDER' | translate }}"
                      (onChange)="userRoleChange($event)"
                      [(ngModel)]="selectedUserRole">
          </p-dropdown>
        </div>
      </div>
      <div *ngIf="selectedUserRole">
        <div class="ui-g">

          <div class="ui-g-6 checkbox-set">
            <div class="ui-g m-b-5 font-bold">
              <div class="ui-g-4 font-bold text-left">{{ 'USER_ROLES.ORGANIZATION_GROUP_LABEL' | translate }}</div>
              <div class="ui-g-2">{{ 'USER_ROLES.PERMISSION_READ' | translate }}</div>
              <div class="ui-g-2">{{ 'USER_ROLES.PERMISSION_UPDATE' | translate }}</div>
            </div>
            <br>
            <div class="ui-g" *ngFor="let label of ORG_PERMISSION_LABELS">
              <div class="ui-g-4 text-left">{{ 'USER_ROLES.' + label | translate }}</div>
              <div class="ui-g-2">
                <p-checkbox [(ngModel)]="selectedPermissions" [value]="label + '_READ'"></p-checkbox>
              </div>
              <div class="ui-g-2" *ngIf="label !== 'DELETE_ORGANIZATION'">
                <p-checkbox [(ngModel)]="selectedPermissions" [value]="label + '_UPDATE'"></p-checkbox>
              </div>
            </div>
          </div>

          <div class="ui-g-6 checkbox-set">
            <div class="ui-g m-b-5 font-bold">
              <div class="ui-g-4 font-bold text-left">{{ 'USER_ROLES.PERSON_GROUP_LABEL' | translate }}</div>
              <div class="ui-g-2">{{ 'USER_ROLES.PERMISSION_READ' | translate }}</div>
              <div class="ui-g-2">{{ 'USER_ROLES.PERMISSION_UPDATE' | translate }}</div>
            </div>
            <br>
            <div class="ui-g" *ngFor="let label of PERSON_PERMISSION_LABELS">
              <div class="ui-g-4 text-left">{{ 'USER_ROLES.' + label | translate }}</div>
              <div class="ui-g-2">
                <p-checkbox *ngIf="label!=='WSD_IDM_PROFILE'" [(ngModel)]="selectedPermissions"
                            [value]="label + '_READ'"></p-checkbox>
              </div>
              <div class="ui-g-2">
                <p-checkbox [(ngModel)]="selectedPermissions" [value]="label + '_UPDATE'"></p-checkbox>
              </div>
            </div>

            <div class="ui-g m-b-5 m-t-15 font-bold">
              <div class="ui-g-4 font-bold text-left">{{ 'USER_ROLES.NDP_GROUP_LABEL' | translate }}</div>
              <div class="ui-g-2">{{ 'USER_ROLES.PERMISSION_READ' | translate }}</div>
              <div class="ui-g-2">{{ 'USER_ROLES.PERMISSION_UPDATE' | translate }}</div>
              <div class="ui-g-2">{{ 'USER_ROLES.PERMISSION_CREATE' | translate }}</div>
              <div class="ui-g-2">{{ 'USER_ROLES.PERMISSION_DELETE' | translate }}</div>
            </div>
            <br>
            <div class="ui-g" *ngFor="let label of NDP_PERMISSION_LABELS">
              <div class="ui-g-4 text-left">{{ 'USER_ROLES.' + label | translate }}</div>
              <div class="ui-g-2">
                <p-checkbox *ngIf="NDP_UPDATE_ONLY_PERMISSIONS.indexOf(label) === -1"
                            [(ngModel)]="selectedPermissions" [value]="label + '_READ'"></p-checkbox>
              </div>
              <div class="ui-g-2">
                <p-checkbox *ngIf="NDP_READ_ONLY_PERMISSIONS.indexOf(label) === -1" [(ngModel)]="selectedPermissions"
                            [value]="label + '_UPDATE'"></p-checkbox>
              </div>
              <div class="ui-g-2">
                <p-checkbox
                  *ngIf="NDP_READ_ONLY_PERMISSIONS.indexOf(label) === -1 && NDP_UPDATE_ONLY_PERMISSIONS.indexOf(label) === -1 && NDP_NOT_CREATE_PERMISSIONS.indexOf(label) === -1"
                  [(ngModel)]="selectedPermissions"
                  [value]="label + '_CREATE'"></p-checkbox>
              </div>
              <div class="ui-g-2">
                <p-checkbox
                  *ngIf="NDP_READ_ONLY_PERMISSIONS.indexOf(label) === -1 && NDP_UPDATE_ONLY_PERMISSIONS.indexOf(label) === -1 && NDP_NOT_DELETE_PERMISSIONS.indexOf(label) === -1"
                  [(ngModel)]="selectedPermissions"
                  [value]="label + '_DELETE'"></p-checkbox>
              </div>
            </div>
          </div>
        </div>

        <div class="ui-g">
          <div class="ui-g-6 checkbox-set">
            <div class="ui-g m-b-5 font-bold">
              <div class="ui-g-4 font-bold text-left">{{ 'USER_ROLES.ADMINISTRATION_GROUP_LABEL' | translate }}</div>
              <div class="ui-g-2">{{ 'USER_ROLES.PERMISSION_READ' | translate }}</div>
              <div class="ui-g-2">{{ 'USER_ROLES.PERMISSION_UPDATE' | translate }}</div>
              <div class="ui-g-2">{{ 'USER_ROLES.PERMISSION_CREATE' | translate }}</div>
            </div>
            <br>
            <div class="ui-g" *ngFor="let label of ADMINISTRATION_LABELS">
              <div class="ui-g-4 text-left">{{ 'USER_ROLES.' + label | translate }}</div>
              <div class="ui-g-2">
                <p-checkbox *ngIf="label !== 'WSD_PERSON' && label !== 'WSD_ORGANIZATION'"
                            [(ngModel)]="selectedPermissions" [value]="label + '_READ'"></p-checkbox>
              </div>
              <div class="ui-g-2">
                <p-checkbox *ngIf="label !== 'WSD_PERSON' && label !== 'WSD_ORGANIZATION' &&
                            READ_ONLY_ADMINISTRATION_LABELS.indexOf(label) === -1"
                            [(ngModel)]="selectedPermissions" [value]="label + '_UPDATE'"></p-checkbox>
              </div>
              <div class="ui-g-2">
                <p-checkbox
                  *ngIf="label !== 'WSD_USER_ROLES' && label !== 'WSD_NOTIFICATIONS' && label !== 'WSD_CLASSIFICATIONS'&&
                           READ_ONLY_ADMINISTRATION_LABELS.indexOf(label) === -1"
                  [(ngModel)]="selectedPermissions" [value]="label + '_CREATE'"></p-checkbox>
              </div>
            </div>
          </div>
        </div>

        <div class="ui-g">
          <div class="ui-g-12">
            <button *gsShowIfHasPermission="['WSD_USER_ROLES_UPDATE']"
                    pButton
                    label="{{ 'USER_ROLES.SAVE_BUTTON' | translate }}"
                    (click)="save()"
                    class="pull-left m-r-15 ui-button-success">
            </button>
            <button pButton label="{{ 'USER_ROLES.DISCARD_BUTTON' | translate }}"
                    class="ui-button-secondary"
                    (click)="discard()">
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<wsd-global-messages [life]="4000"></wsd-global-messages>
